import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import blogs from './Pages/Blogs/data';

const SITE_URL = 'https://alutuff.in';

const ROUTE_CONFIG = {
  '/': {
    title: 'ACP Sheets Manufacturer in India | Alutuff Panels',
    description: 'Alutuff is a leading ACP sheets manufacturer in India, producing premium aluminium composite panels for modern facades, interior cladding, and signage.',
    canonical: `${SITE_URL}/`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
  },
  '/about': {
    title: 'About Alutuff | ACP Sheet Manufacturer in Bareilly India',
    description: "Learn about Alutuff, India's trusted aluminium composite panel manufacturer with a 5 lakh sq ft Bareilly plant delivering ISO-certified ACP solutions.",
    canonical: `${SITE_URL}/about`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'About Us',
  },
  '/products': {
    title: 'Aluminium Composite Panels & ACP Sheets India | Alutuff',
    description: 'Explore Alutuff ACP sheets and aluminium composite panels. Choose fire-retardant ACP, wooden finish ACP sheets, marble textures, and louvers for facades.',
    canonical: `${SITE_URL}/products`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Products',
  },
  '/product': {
    title: 'Aluminium Composite Panels & ACP Sheets India | Alutuff',
    description: 'Explore Alutuff ACP sheets and aluminium composite panels. Choose fire-retardant ACP, wooden finish ACP sheets, marble textures, and louvers for facades.',
    canonical: `${SITE_URL}/products`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Products',
  },
  '/projects': {
    title: 'ACP Sheet Facade Projects Across India | Alutuff Panels',
    description: 'View architectural ACP facade and cladding projects completed by Alutuff across India, covering commercial towers, corporate hubs, and institutions.',
    canonical: `${SITE_URL}/projects`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Projects',
  },
  '/career': {
    title: 'Careers at Alutuff | Join Our ACP Sheet Panel Team',
    description: 'Build your career with Alutuff, a premier aluminium composite panel manufacturer in India. Explore job openings in engineering, sales, and operations.',
    canonical: `${SITE_URL}/career`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Careers',
  },
  '/news': {
    title: 'News & Events | Aluminium Composite Panels Alutuff India',
    description: 'Stay updated with the latest news, exhibitions, product launches, and industry updates from Alutuff, leading ACP sheet manufacturer in India.',
    canonical: `${SITE_URL}/news`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'News & Events',
  },
  '/test-report': {
    title: 'ACP Sheet Test Reports & Fire Safety Data | Alutuff',
    description: 'Access technical test reports and quality certifications for Alutuff aluminium composite panels, verifying fire resistance, peel strength, and durability.',
    canonical: `${SITE_URL}/test-report`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Test Reports',
  },
  '/testReport': {
    title: 'ACP Sheet Test Reports & Fire Safety Data | Alutuff',
    description: 'Access technical test reports and quality certifications for Alutuff aluminium composite panels, verifying fire resistance, peel strength, and durability.',
    canonical: `${SITE_URL}/test-report`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Test Reports',
  },
  '/certificates': {
    title: 'ISO Certifications & ACP Quality Standards | Alutuff',
    description: 'Review ISO quality certifications and environmental compliances for Alutuff ACP sheets and architectural aluminium composite panel manufacturing.',
    canonical: `${SITE_URL}/certificates`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Certificates',
  },
  '/contact': {
    title: 'Contact Alutuff | ACP Sheet Enquiries Bareilly India',
    description: 'Contact Alutuff for aluminium composite panel enquiries, quotes, and samples. Visit our Bareilly headquarters or get in touch with our sales team.',
    canonical: `${SITE_URL}/contact`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Contact Us',
  },
  '/catalogues': {
    title: 'Download ACP Sheet Catalogues & Shade Cards | Alutuff',
    description: 'Download official Alutuff ACP sheet shade cards, design catalogues, and technical brochures to explore modern finishes, textures, and specifications.',
    canonical: `${SITE_URL}/catalogues`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Catalogues',
  },
  '/established': {
    title: 'Established Excellence in ACP Panel Manufacturing | Alutuff',
    description: "Discover Alutuff's journey of manufacturing excellence in aluminium composite panels, state-of-the-art infrastructure, and pan-India dealer networks.",
    canonical: `${SITE_URL}/established`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Established Excellence',
  },
  '/dealer': {
    title: 'Become an ACP Sheet Dealer & Distributor | Alutuff India',
    description: 'Partner with Alutuff as an authorized ACP sheet dealer or distributor in India. Enjoy competitive pricing, pan-India logistics, and premium panels.',
    canonical: `${SITE_URL}/dealer`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Become A Dealer',
  },
  '/blog': {
    title: 'ACP Sheets & Architecture Insights Blog | Alutuff',
    description: 'Read expert insights, facade design trends, and architectural tips on aluminium composite panels and modern ACP cladding from Alutuff specialists.',
    canonical: `${SITE_URL}/blog`,
    ogImage: `${SITE_URL}/image/alutuff-og.jpg`,
    ogType: 'website',
    breadcrumbName: 'Blogs',
  },
};

export default function SEO() {
  const location = useLocation();
  const rawPath = location.pathname || '/';
  // Normalize path (strip trailing slash if not root)
  const pathname = rawPath.length > 1 && rawPath.endsWith('/') ? rawPath.slice(0, -1) : rawPath;

  // 1. Check if 404
  if (pathname === '/404.html' || pathname === '/404') {
    return (
      <Helmet>
        <title>404 - Page Not Found | Alutuff</title>
        <meta name="description" content="The page you requested could not be found. Explore ACP sheets, aluminium composite panels, and architectural cladding from Alutuff India." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  // 2. Check if Blog Post
  if (pathname.startsWith('/blog/')) {
    const slug = pathname.replace('/blog/', '');
    const blog = blogs.find((b) => b.slug === slug);

    const title = blog?.metaTitle && blog.metaTitle.length >= 50 && blog.metaTitle.length <= 60
      ? blog.metaTitle
      : (blog ? `${blog.title.slice(0, 48).trim()} | Alutuff` : 'ACP Architecture Blog | Alutuff');
    const description = blog?.metaDescription && blog.metaDescription.length >= 140 && blog.metaDescription.length <= 160
      ? blog.metaDescription
      : 'Explore comprehensive insights, technical guides, and architectural design ideas for aluminium composite panels and ACP sheet installations across India.';
    const canonical = `${SITE_URL}/blog/${slug}`;
    const ogImage = blog?.image
      ? (blog.image.startsWith('http') ? blog.image : `${SITE_URL}${blog.image}`)
      : `${SITE_URL}/image/alutuff-og.jpg`;

    const articleSchema = {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: blog?.title || title,
      description: description,
      datePublished: '2025-12-22T08:00:00+05:30',
      dateModified: '2026-01-15T10:00:00+05:30',
      author: {
        '@type': 'Organization',
        name: 'Alutuff',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Alutuff',
        logo: {
          '@type': 'ImageObject',
          url: `${SITE_URL}/logo512.png`,
        },
      },
      image: ogImage,
      mainEntityOfPage: canonical,
    };

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${SITE_URL}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Blogs',
          item: `${SITE_URL}/blog`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: blog?.title || 'Article',
          item: canonical,
        },
      ],
    };

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta name="robots" content="index, follow, max-image-preview:large" />

        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:site_name" content="Alutuff" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
    );
  }

  // 3. Static Route Configuration
  const config = ROUTE_CONFIG[pathname] || ROUTE_CONFIG['/'];

  // Schemas per page
  let schemas = [];

  if (pathname === '/' || pathname === '/home') {
    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Alutuff',
      legalName: 'Alutuff International',
      url: `${SITE_URL}/`,
      logo: `${SITE_URL}/logo512.png`,
      image: `${SITE_URL}/alutuff-acp-sheets-manufacturer-supplier-india.jpg`,
      description: 'Alutuff is an ACP sheet manufacturer in India offering Aluminium Composite Panels for building facades, interiors, signage and architectural applications.',
      telephone: '+91 63968 54974',
      email: 'sales@alutuff.in',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Choupla Road, Civil Lines',
        addressLocality: 'Bareilly',
        addressRegion: 'Uttar Pradesh',
        postalCode: '243001',
        addressCountry: 'IN',
      },
      sameAs: [
        'https://www.facebook.com/profile.php?id=61578129710470',
        'https://www.instagram.com/alutuff.panels/',
        'https://www.linkedin.com/company/alutuff/',
      ],
    };

    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Alutuff',
      alternateName: 'Alutuff ACP Sheets',
      url: `${SITE_URL}/`,
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Where can Alutuff panels be used?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Alutuff panels are ideal for both interior and exterior use—like facades, signage, ceilings, partitions, and wall cladding in homes, offices, and commercial spaces.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are Alutuff panels fire and weather resistant?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, Alutuff panels are engineered to be fire-retardant and weather-resistant, offering long-term durability in all environmental conditions.',
          },
        },
        {
          '@type': 'Question',
          name: 'What finishes and textures are available?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Alutuff panels come in a wide variety of textures and looks, including wooden, metallic, matte, gloss, marble, and custom 3D decorative finishes.',
          },
        },
        {
          '@type': 'Question',
          name: 'What sizes and thicknesses do Alutuff panels come in?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Panels are available in multiple sizes like 1220×2440mm, 1220×3050mm, and thicknesses from 3mm to 6mm, with custom sizes available on request.',
          },
        },
      ],
    };

    schemas = [orgSchema, websiteSchema, faqSchema];
  } else if (pathname === '/products' || pathname === '/product') {
    const itemListSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Alutuff ACP Sheet Products',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'Product',
            name: 'Wooden Prime ACP Sheets',
            brand: { '@type': 'Brand', name: 'Alutuff' },
            description: 'Premium wooden finish ACP sheets for interior and exterior architectural cladding.',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'Product',
            name: 'Marble & Stone Series ACP Sheets',
            brand: { '@type': 'Brand', name: 'Alutuff' },
            description: 'Natural stone and Italian marble finish Aluminium Composite Panels.',
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'Product',
            name: 'Louvers – Aluminium Louvers',
            brand: { '@type': 'Brand', name: 'Alutuff' },
            description: 'Elegant architectural shading and sunshade solutions for modern building facades.',
          },
        },
      ],
    };

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${SITE_URL}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Products',
          item: config.canonical,
        },
      ],
    };

    schemas = [itemListSchema, breadcrumbSchema];
  } else {
    // Other inner pages get BreadcrumbList
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${SITE_URL}/`,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: config.breadcrumbName || 'Page',
          item: config.canonical,
        },
      ],
    };
    schemas = [breadcrumbSchema];
  }

  return (
    <Helmet>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <link rel="canonical" href={config.canonical} />
      <meta name="robots" content="index, follow, max-image-preview:large" />

      <meta property="og:type" content={config.ogType || 'website'} />
      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:url" content={config.canonical} />
      <meta property="og:image" content={config.ogImage || `${SITE_URL}/image/alutuff-og.jpg`} />
      <meta property="og:site_name" content="Alutuff" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={config.title} />
      <meta name="twitter:description" content={config.description} />
      <meta name="twitter:image" content={config.ogImage || `${SITE_URL}/image/alutuff-og.jpg`} />

      {schemas.map((s, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
